// App.js - Complete version with Footer after Contact

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navbar from "./component/Navbar";
import Heron from "./component/Heron";
import About from "./component/About";
import Education from "./component/Education";
import Publication from "./component/Publication";
import Skill from "./component/Skill";
import Mywork from "./component/Mywork";
import Testimonials from "./component/TestimonialsPage";
import Contactn from "./component/Contactn";
import { FaGithub, FaTelegram, FaLinkedin } from 'react-icons/fa';

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen bg-slate-100">
      {/* NAVBAR */}
      <Navbar />

      {/* MAIN CONTENT - Completely flush to edges */}
      <div className="flex justify-start w-full">
        <main className="w-full flex flex-col lg:flex-row lg:items-start">
          {/* LEFT: profile sidebar - absolutely flush to left edge */}
          <aside className="w-full lg:w-[45%] lg:max-w-[650px] lg:sticky lg:top-0 lg:self-start lg:h-screen">
            <Heron />
          </aside>

          {/* RIGHT: all other sections stacked vertically */}
          <section className="w-full lg:w-[55%] lg:flex-1 space-y-16 px-4 py-4 lg:px-8 lg:pr-12">
            <About />
            <Education />
            <Publication />
            <Mywork />
            <Skill />
            <Testimonials />
            <Contactn />
            
            
            
            {/* Footer Section - After Contact */}
            <footer className="bg-white text-white py-10 rounded-2xl shadow-lg">
              <div className="max-w-5xl mx-auto px-4">
                <div>
                  {/* Social Media Icons */}
                  <div className="flex gap-6 text-center justify-center items-center mb-4">
                    <a 
                      href="https://github.com/teshe1221" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-slate-700 hover:text-slate-900 transition-colors duration-300"
                    >
                      <FaGithub size={30} />
                    </a>
                    
                    <a 
                      href="https://t.me/CToneRobot" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-slate-700 hover:text-slate-900 transition-colors duration-300"
                    >
                      <FaTelegram size={30} />
                    </a>
                    
                    <a 
                      href="https://www.linkedin.com/in/teshome-getaw-b44b33255?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B8yUjHjagQEmM9j4Do1Rc2Q%3D%3D" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-slate-700 hover:text-slate-900 transition-colors duration-300"
                    >
                      <FaLinkedin size={30} />
                    </a>
                  </div>
                  
                  {/* Copyright */}
                  <div className="text-center">
                    <p className="text-gray-500">&copy; 2024 All rights reserved.</p>
                  </div>
                </div>
              </div>
            </footer>
          </section>
        </main>
      </div>
    </div>
  );
}

export default App;